import { inject, Injectable } from '@angular/core';
import { HomeFeedSection, HomeFeedService } from '@brightside-web/desktop/feature/home-feed';
import { ServiceInventoryService, ServiceState } from '@brightside-web/desktop/data-access/service-inventory';
import { filter, tap } from 'rxjs/operators';
import {
  NewSavingsAccountService,
  SavingsCompleteCardComponent,
  SavingsInitialCardComponent,
} from '@brightside-web/desktop/feature/savings-account';
import { Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SavingsCardService {
  private _homeFeedService = inject(HomeFeedService);
  private _serviceInventory = inject(ServiceInventoryService);
  private _savingsSvc: NewSavingsAccountService = inject(NewSavingsAccountService);
  private _sub = new Subscription();

  constructor() {
    this._sub.add(
      this._serviceInventory
        .getService('savings')
        .pipe(
          filter((service) => !!service),
          tap((service) => {
            switch (service.state) {
              case ServiceState.INITIAL:
                this.registerSavingsInitialCard();
                break;
              case ServiceState.MAINTENANCE:
                break;
              default:
                this.registerSavingsCompleteCard();
                break;
            }
          })
        )
        .subscribe()
    );
  }

  ngOnDestroy() {
    this._sub.unsubscribe();
  }

  private registerSavingsInitialCard() {
    this._homeFeedService.registerHomeFeedCard({
      key: 'savings',
      component: 'SavingsInitialCardComponent',
      componentRef: SavingsInitialCardComponent,
      data: null,
      order: 1,
      section: HomeFeedSection.MYMONEYINITIAL,
    });
  }

  private registerSavingsCompleteCard() {
    this._savingsSvc.getSavingsAccounts();
    this._homeFeedService.removeHomeFeedCard('savings', HomeFeedSection.MYMONEYINITIAL);
    this._homeFeedService.registerHomeFeedCard({
      key: 'savings',
      component: 'SavingsCompleteCardComponent',
      componentRef: SavingsCompleteCardComponent,
      data: null,
      order: 1,
      section: HomeFeedSection.MYMONEYCOMPLETE,
    });
  }
}
